/**
 * Baked-in snapshot extracted from the local `ubond` MySQL database.
 * `PARTNER_COUPONS` contains the 10 most recent active `offer_type='coupon'`
 * coupons owned by real partner businesses, excluding the platform demo
 * accounts `business001` and `company000000021`. `PARTNER_BUSINESSES` contains
 * 18 real partner businesses and their coupon counts. Icons are real partner
 * logos from `business_profiles.icon` (populated from production
 * `users.profile_icon`). Cloudinary coupon URLs are normalized to HTTPS.
 */

export type PartnerBusiness = {
  id: string;
  name: string;
  icon: string;
  couponCount: number;
};

export type PartnerCoupon = {
  id: string;
  business: string;
  name: string;
  points: number | null;
  image: string | null;
};

export const PARTNER_BUSINESSES: PartnerBusiness[] = [
  {
    id: "company00000007",
    name: "生月殿 Monku Beauty Salon",
    icon:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1721458949/Screenshot_2024-07-20_at_3.02.24_PM_tgpowe.png",
    couponCount: 14,
  },
  {
    id: "company00000010",
    name: "The Peach Beauty",
    icon:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1721916194/Screenshot_2024-07-25_at_10.03.09_PM_zmah5m.png",
    couponCount: 8,
  },
  {
    id: "company00000014",
    name: "Aqua Pro Beauty Limited",
    icon:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1724753701/Logo_-_AQUA_Pro_png_yogzrz.png",
    couponCount: 7,
  },
  {
    id: "company00000005",
    name: "Bare Limited",
    icon:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1721452916/Screenshot_2024-07-20_at_1.21.49_PM_npve9p.png",
    couponCount: 4,
  },
  {
    id: "company00000003",
    name: "Frankly Talkie",
    icon:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1721001443/Screenshot_2024-07-15_at_7.57.14_AM_h52vs1.png",
    couponCount: 2,
  },
  {
    id: "company00000013",
    name: "EVRBEAUTY",
    icon:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1722049152/Screenshot_2024-07-27_at_10.59.02_AM_dg3ynn.png",
    couponCount: 2,
  },
  {
    id: "company00000002",
    name: "Ball Ball Expert",
    icon:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1720778787/Screenshot_2024-07-12_at_6.06.22_PM_e6ioho.png",
    couponCount: 2,
  },
  {
    id: "company00000009",
    name: "Luckyone.Florist",
    icon:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1721914999/luckyone_hk_%E8%B2%B7%E6%BB%BF200%E5%85%83%E4%BA%AB%E6%9C%899%E6%8A%98_qsznxy.png",
    couponCount: 2,
  },
  {
    id: "company00000019",
    name: "迴廊劇本殺",
    icon:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1728472838/WhatsApp_Image_2024-09-30_at_12.20.52_fnzo9k.jpg",
    couponCount: 2,
  },
  {
    id: "company00000016",
    name: "RP KUN",
    icon:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1726297703/WhatsApp_Image_2024-08-15_at_13.54.58_tkgfsf.jpg",
    couponCount: 2,
  },
  {
    id: "company00000008",
    name: "ENVUS HOMME",
    icon:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1721543013/Screenshot_2024-07-21_at_2.23.26_PM_v2hwgv.png",
    couponCount: 1,
  },
  {
    id: "company00000011",
    name: "OLMA YOGA",
    icon:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1721958031/Screenshot_2024-07-26_at_9.40.26_AM_uuboqq.png",
    couponCount: 1,
  },
  {
    id: "company00000017",
    name: "Sky Beauty",
    icon:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1727611082/WhatsApp_Image_2024-09-21_at_12.00.46_q5qs4e.jpg",
    couponCount: 1,
  },
  {
    id: "company00000020",
    name: "Awaken",
    icon:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1728473068/Screenshot_2024-10-09_at_7.24.22_PM_y4e8o9.png",
    couponCount: 1,
  },
  {
    id: "company00000004",
    name: "RC Fitness Studio",
    icon:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1721449613/Screenshot_2024-07-20_at_12.26.44_PM_yail2z.png",
    couponCount: 1,
  },
  {
    id: "company00000001",
    name: "學車go",
    icon:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1719403347/hokcego_1_uhl8xa.png",
    couponCount: 1,
  },
  {
    id: "company00000015",
    name: "FREE POINT CLOTHING WAREHOUSE",
    icon:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1725957031/download_r2spvr.png",
    couponCount: 1,
  },
  {
    id: "company00000012",
    name: "Bear__Brows",
    icon:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1722049310/WhatsApp_Image_2024-07-26_at_9.07.21_PM_jywwe5.jpg",
    couponCount: 1,
  },
];

export const PARTNER_COUPONS: PartnerCoupon[] = [
  {
    id: "80f5efbf-01bb-4c2d-8382-fa8336393056",
    business: "Awaken",
    name: "原價10堂 $500/堂 學生優惠 8堂 $350/堂",
    points: 400,
    image:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1728538408/%E5%8E%9F%E5%83%B910%E5%A0%82_500%E5%A0%82_%E5%AD%B8%E7%94%9F%E5%84%AA%E6%83%A0_8%E5%A0%82_350%E5%A0%82_qrj8xu.png",
  },
  {
    id: "8f057406-c10b-45b8-831c-467abdc1b241",
    business: "迴廊劇本殺",
    name: "公眾假期五六日 玩本-$40/每位",
    points: 400,
    image:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1728537009/%E5%85%AC%E7%9C%BE%E5%81%87%E6%9C%9F%E4%BA%94%E5%85%AD%E6%97%A5_%E7%8E%A9%E6%9C%AC-_40%E6%AF%8F%E4%BD%8D_yd1tvq.png",
  },
  {
    id: "7f5fe1ea-e66d-4182-85c6-51142ee1bc24",
    business: "迴廊劇本殺",
    name: "平日（星期一到星期四）: 玩本-$80/每位",
    points: 400,
    image:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1728536784/%E5%B9%B3%E6%97%A5_%E6%98%9F%E6%9C%9F%E4%B8%80%E5%88%B0%E6%98%9F%E6%9C%9F%E5%9B%9B_%E7%8E%A9%E6%9C%AC-_50%E6%AF%8F%E4%BD%8D_gs5d4m.png",
  },
  {
    id: "3ab456e6-4dc2-4b50-b4c5-cba337e1aee3",
    business: "Sky Beauty",
    name: "Sky Beauty🌟【O3藍光KO暗瘡】🌟$380",
    points: 500,
    image:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1727885116/Sky_Beauty_O3%E8%97%8D%E5%85%89KO%E6%9A%97%E7%98%A1_380_lo3di2.png",
  },
  {
    id: "f13f063a-8aae-4120-adef-f8fac93f9822",
    business: "RP KUN",
    name: "預約閒日玩劇本殺 九折再九折",
    points: 100,
    image:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1726298915/RP_KUN_%E9%A0%90%E7%B4%84%E9%96%92%E6%97%A5%E5%8A%87%E6%9C%AC%E6%AE%BA_%E4%B9%9D%E6%8A%98%E5%86%8D%E4%B9%9D%E6%8A%98_hcggiw.png",
  },
  {
    id: "95c46e0b-cbc9-4b87-99b2-e0bbd21cda5c",
    business: "RP KUN",
    name: "預約星期六/日玩劇本殺 九折",
    points: 100,
    image:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1726297615/RP_KUN_%E6%98%9F%E6%9C%9F%E5%85%AD%E6%97%A5%E9%A0%90%E7%B4%84%E5%8A%87%E6%9C%AC%E6%AE%BA_%E4%B9%9D%E6%8A%98_aeowi9.png",
  },
  {
    id: "b3ef13d4-9911-4a00-9eef-18041f456064",
    business: "FREE POINT CLOTHING WAREHOUSE",
    name: "購買任何ATACARSTORE 上面的產品全部八五折",
    points: 100,
    image:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1725954332/ATACAR_%E6%89%80%E6%9C%89%E7%94%A2%E5%93%81%E5%85%AB%E4%BA%94%E6%8A%98_hy7jyj.png",
  },
  {
    id: "2a2e6e23-8cb1-42e6-be15-4cdf1805e956",
    business: "Aqua Pro Beauty Limited",
    name: "MX6消脂減腩 (45分鐘) $388 再九折(3次)",
    points: 500,
    image:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1724767739/Aqua_Beauty_MX6%E6%B6%88%E8%84%82%E6%B8%9B%E8%85%A9_45%E5%88%86%E9%90%98_388_3%E6%AC%A1_2_txe33u.png",
  },
  {
    id: "3a18c4da-f2c1-413a-8123-de0c77d4d451",
    business: "Aqua Pro Beauty Limited",
    name: "日本新技術MRM筋膜痛症理療技術 (進化版) (60分鐘) $288 再九折",
    points: 500,
    image:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1724767522/Aqua_Beauty_%E6%97%A5%E6%9C%AC%E6%96%B0%E6%8A%80%E8%A1%93MRM%E7%AD%8B%E8%86%9C%E7%97%9B%E7%97%87%E7%90%86%E7%99%82%E6%8A%80%E8%A1%93_%E9%80%B2%E5%8C%96%E7%89%88_60%E5%88%86%E9%90%98_288_ux2wer.png",
  },
  {
    id: "a8207a86-eed2-4f81-9bfe-c32d54a65fdf",
    business: "Aqua Pro Beauty Limited",
    name: "神黑石溫筋舒壓養生療法 (60分鐘) $218 再九折",
    points: 500,
    image:
      "https://res.cloudinary.com/dt0cvvayr/image/upload/v1724767519/Aqua_Beauty_%E7%A5%9E%E9%BB%91%E7%9F%B3%E6%BA%AB%E7%AD%8B%E8%88%92%E5%A3%93%E9%A4%8A%E7%94%9F%E7%99%82%E6%B3%95_60%E5%88%86%E9%90%98_218_xf9xpv.png",
  },
];
